import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useMemo,
} from "react";
import { FF2Step, FormData } from "../types";
import { calculateNextStep } from "../nextStepCalculator";

interface FormContextProps {
  formData: FormData;
  setFormData: React.Dispatch<React.SetStateAction<FormData>>;
  recalculateStep: () => void;
  step: FF2Step;
  setStep: React.Dispatch<React.SetStateAction<FF2Step>>;
}

const FormContext = createContext<FormContextProps | undefined>(undefined);

export const FormProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [formData, setFormData] = useState<FormData>({} as FormData);
  const [step, setStep] = useState<FF2Step>(FF2Step.Start);

  const recalculateStep = () => {
    const nextStep = calculateNextStep(step, formData);
    setStep(nextStep);
  }

  const contextValue = useMemo(
    () => ({
      formData,
      setFormData,
      recalculateStep,
      step,
      setStep,
    }),
    [formData, setFormData, step, setStep, recalculateStep]
  );

  return <FormContext.Provider value={contextValue}>{children}</FormContext.Provider>;
};

export const useFormContext = (): FormContextProps => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error("useFormData must be used within a FormDataProvider");
  }
  return context;
};
